import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Announcement } from 'types/announcements';
import { AppDispatch, RootState } from 'redux/store';
import DeleteModal from 'components/Common/DeleteModal';
import Table from 'components/Common/StyledTable';
import routes from 'constants/routes';
import { dateFormat, timeFormat } from 'utils/helpers';
import { deleteAnnouncementById } from 'redux/slices/announcements/announcementsSlice';

const AnnouncementColumns = [
    { id: 'createDate', label: 'Date', render: ({ value }: any) => dateFormat(value) },
    { id: 'createTime', label: 'Time', render: ({ data }: any) => timeFormat(data?.['createDate']) },
    { id: 'title', label: 'Title' },
];

function AnnouncementContainer({ data, loading }: any) {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [announcement, setAnnouncement] = useState<any>(null);
    const { totalCount } = useSelector((state: RootState) => ({
        totalCount: state.announcement.announcementsList?.totalCount,
    }));

    const navigationHandler = useCallback(
        (row: any) => {
            navigate(routes.announcements.details.replace(':id', row?.id));
        },
        [navigate]
    );

    const handleDeleteClick = useCallback((announcement: Announcement) => {
        setOpenDeleteModal(true);
        setAnnouncement(announcement);
    }, []);

    const deleteAnnouncement = useCallback(async () => {
        setDeleteLoading(true);
        const { payload }: any = await dispatch(deleteAnnouncementById(announcement?.id));
        setDeleteLoading(false);
        if (payload?.code === 200) {
            setOpenDeleteModal(false);
        }
    }, [dispatch, announcement?.id]);

    return (
        <div>
            <Table
                unStyled
                showDeleteCell
                serverSidePagination
                totalCount={totalCount}
                columns={AnnouncementColumns}
                data={data}
                navigationHandler={navigationHandler}
                onDeleteClick={handleDeleteClick}
                loading={loading}
            />
            <DeleteModal
                isOpen={openDeleteModal}
                title="Delete Announcement"
                description="Are you sure you want to delete the selected announcement!"
                onClose={() => setOpenDeleteModal(false)}
                onDelete={deleteAnnouncement}
                loading={deleteLoading}
            />
        </div>
    );
}

export default AnnouncementContainer;
